/**
 * Opt-in client navigation tracing (no console noise by default).
 *
 * Enable either:
 *   localStorage.setItem("afomaDebugNav", "1")
 * or open any URL with ?debugNav=1 once (then navigate; query may drop on some links).
 *
 * Watch for: [AFOMA Nav] routeChangeComplete after each click, and Cart unmount when leaving /cart.
 */
export function isNavDebugEnabled() {
  if (typeof window === "undefined") return false;
  try {
    if (new URLSearchParams(window.location.search).get("debugNav") === "1") return true;
    if (window.localStorage?.getItem("afomaDebugNav") === "1") return true;
  } catch (_) {
    /* ignore */
  }
  return false;
}

export function navDebugLog(label, payload) {
  if (!isNavDebugEnabled()) return;
  if (payload !== undefined) {
    console.info(`[AFOMA Nav] ${label}`, payload);
  } else {
    console.info(`[AFOMA Nav] ${label}`);
  }
}
